// AI-CONTEXT: See docs/features/updates-log.md
// Zet de ISO-datum van een update om naar '26 augustus 2026'.

// Bewust een vaste lijst en géén Intl/toLocaleDateString: de repo-lokale node
// draait small-icu, waardoor locale-uitvoer per omgeving verschilt en tests
// "alleen in de volledige suite" omvallen.
const MAANDEN = [
    'januari', 'februari', 'maart', 'april', 'mei', 'juni',
    'juli', 'augustus', 'september', 'oktober', 'november', 'december',
]

const ISO_DATUM = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * @param {*} date - ISO-datum uit updates.json, bv. '2026-08-26'
 * @returns {string} '26 augustus 2026', of '' als de datum onbruikbaar is
 */
const formatUpdateDate = (date) => {
    const match = typeof date === 'string' ? date.match(ISO_DATUM) : null
    if (!match) return ''

    const [, jaar, maand, dag] = match
    const maandIndex = Number(maand) - 1
    const dagNummer = Number(dag)

    if (maandIndex < 0 || maandIndex > 11) return ''
    if (dagNummer < 1) return ''

    // Een bestaande kalenderdatum: 30 februari mag niet als '30 februari'
    // doorglippen. Date rolt zo'n dag door naar de volgende maand, dus de
    // teruggelezen maand verraadt het.
    const gecontroleerd = new Date(Date.UTC(Number(jaar), maandIndex, dagNummer))
    if (gecontroleerd.getUTCMonth() !== maandIndex || gecontroleerd.getUTCDate() !== dagNummer) {
        return ''
    }

    return `${dagNummer} ${MAANDEN[maandIndex]} ${Number(jaar)}`
}

export { MAANDEN }
export default formatUpdateDate
